import React, { memo, MutableRefObject } from 'react';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';
import HBTextArea from '../HBTextArea/HBTextArea';
import { HBTextAreaProps } from '../HBTextArea/HBTextArea.types';

export interface HBTextAreaFieldProps
    extends HBBaseFormFieldProps,
        Omit<HBTextAreaProps, 'size'> {
    /** HTML `id` for the field; used as the `<label htmlFor>` target. Required. */
    id: string;
    /** Ref forwarded to the underlying HBTextArea element. */
    inputRef?: MutableRefObject<HTMLTextAreaElement>;
}

const SIZE_CORRECTION_MAP: Record<
    'xs' | 'sm' | 'md' | 'lg',
    HBTextAreaProps['size']
> = {
    xs: 'xs',
    sm: 'xs',
    md: 'sm',
    lg: 'md'
};

const HBTextAreaField = ({
    inputRef,
    size = 'sm',
    ...props
}: HBTextAreaFieldProps) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps} size={size}>
            <HBTextArea
                {...inputProps}
                size={SIZE_CORRECTION_MAP[size]}
                ref={inputRef}
            />
        </HBBaseFormField>
    );
};

export default memo(HBTextAreaField);
